import "react-responsive-carousel/lib/styles/carousel.min.css";
import Header from "./Header";
import Footer from "./Footer";

import { HashLink } from "react-router-hash-link";

const services = [
  {
    title: "Laboratory ",
    desc: "Rapid-lab provides a wide range of essential services that support the diagnosis, treatment, and prevention of diseases.",
    link: "/laboratoryServices#lab-services",
    btn: "Laboratory",
  },
  {
    title: "Digital X-Ray",
    desc: "Computed Tomography (CT) combines multiple X-ray images taken from different angles to create detailed cross-sectional views of the body. These images provide comprehensive information about internal organs, bones, blood vessels, and soft tissues. By stacking the slices together, a CT scan produces highly detailed, 3D-like images that help doctors diagnose conditions, plan treatments, and guide procedures with greater accuracy than standard X-rays.",
    link: "/DigitalXrayServices#x-ray-services",
    btn: "X-Ray",
  },
  {
    title: "Hysterosalpingogram (HSG)",
    desc: "Uses multiple X-ray images to provide detailed information about the uterus and fallopian tubes, helping to assess their structure and detect any blockages or abnormalities.",
    link: "/HsgServices#hsg-services",
    btn: "HSG",
  },
  {
    title: "Ultrasound",
    desc: "Uses high-frequency sound waves to create images of the body’s internal structures. It helps visualize superficial tissues, organs, and blood vessels in real time. By detecting how different tissues reflect sound waves, it provides detailed images that assist in diagnosis and monitoring of various medical conditions without using radiation.",
    link: "/UltrasoundServices#ultrasound-services",
    btn: "Ultrasound",
  },
  {
    title: "Sonography",
    desc: "A transducer is placed on the skin with a special gel to help sound waves pass through the body. It emits high-frequency, inaudible sound waves that bounce off internal structures. The echoes are captured by the transducer, sent to a computer, and converted into real-time images, allowing different tissues to be distinguished.",
    link: "/SonographyServices#sonography-services",
    btn: "Sonography",
  },
  {
    title: "Electrocardiogram (ECG)",
    desc: "An electrocardiogram (ECG) is a diagnostic test that records the heart’s electrical activity, showing the timing and strength of heartbeats. It helps detect irregular heart rhythms, heart damage, and other cardiac conditions.",
    link: "/EcgServices#ecg-services",
    btn: "ECG",
  },
  {
    title: "Mobile Concierge",
    desc: "Our Mobile Concierge service brings healthcare directly to your doorstep. Whether you need routine check-ups, diagnostic tests, or specialized care, our team of healthcare professionals will come to you, providing personalized and convenient medical services in the comfort of your home.",
    link: "/MobileConciergeServices#mobileConcierge-services",
    btn: "Mobile Concierge",
  },
  {
    title: "Echocardiogram (Echo)",
    desc: "An echocardiogram (Echo) is a non-invasive medical imaging test that uses ultrasound waves to create detailed images of the heart’s structure and function. It helps evaluate heart chambers, valves, and blood flow, aiding in the diagnosis of various cardiac conditions.",
    link: "/EchoServices#echo-services",
    btn: "Echo",
  },
  {
    title: "Corporate Wellness",
    desc: "Our Corporate Wellness programs are designed to promote health and well-being in the workplace. We offer comprehensive health screenings, educational workshops, and personalized wellness plans to help your employees maintain a healthy lifestyle and reduce healthcare costs.",
    link: "/CorporateServices#corporate-wellness-services",
    btn: "Corporate Wellness",
  },
];

function Services() {
  return (
    <>
      <div id="rapid-services" className="page"></div>
      <Header />

      <section className="container-fluid  ">
        <div className=" ">
          <h1
            className="text-primary-emphasis mx-lg-5  px-lg-5  text-start px-3 mb-0 "
            style={{ fontSize: "50px" }}
          >
            Services
          </h1>

          <div className="container py-5">
            <div className="row align-items-center">
              {/* Left Content */}
              <div className="col-md-6 mb-0 ">
                <h4
                  className="fw-semibold"
                  style={{
                    color: "#1f2d5a",
                    fontSize: "39px",
                    lineHeight: "1.0",
                  }}
                >
                  Your care & peace of mind <br />
                  is important to us.
                </h4>

                {/* Underline */}
                <div
                  style={{
                    width: "40%",
                    height: "5px",
                    backgroundColor: "gold",
                    margin: "4px ",
                  }}
                ></div>

                <p
                  className="text-primary-emphasis pt-4"
                  style={{ maxWidth: "500px" }}
                >
                  <strong className="text-primary-emphasis">Rapid Lab</strong>{" "}
                  provides a variety of exams and procedures in a comfortable
                  outpatient environment. with ultra-modern equipment and the
                  latest technology to provide a comprehensive range of
                  emergency, routine, and specialized laboratory tests. If you
                  would like to know more about your upcoming exam or procedure,
                  please click below for a more detailed description.
                </p>
              </div>

              <div className="col-md-6 text-center">
                <img
                  src="https://images.unsplash.com/photo-1501785888041-af3ef285b470"
                  alt="Scenery"
                  className="img-fluid"
                  style={{
                    borderRadius: "10px",
                    maxWidth: "100%",
                    height: "auto",
                  }}
                />
              </div>
            </div>
          </div>
        </div>

        <div className="bg-light border border-1 rounded py-5">
          <div className="container">
            {/* Section Title */}
            <div className="text-center mb-5">
              <h2 style={{ color: "#1f2d5a" }}>
                Laboratory services we offer:
              </h2>

              <div
                className="mx-auto mt-3"
                style={{
                  width: "70px",
                  height: "4px",
                  backgroundColor: "#FFD700",
                }}
              ></div>
            </div>

            {/* Cards */}
            <div className="row g-4 ">
              {services.map((service, index) => (
                <div className="col-md-4" key={index}>
                  <div
                    className="p-4 h-100 bg-light shadow-sm rounded"
                    style={{
                      borderTop: "4px solid #FFD700",
                    }}
                  >
                    <h5 className="fw-normal" style={{ color: "#1f2d5a" }}>
                      {service.title}
                    </h5>
                    <p className="text-muted mt-3 l-lines">{service.desc}</p>
                    <HashLink
                      className="text-decoration-none d-flex align-items-center justify-content-center"
                      to={service.link}
                    >
                      <button
                        className="btn btn-lg btn-outline-primary px-4 m-auto"
                        style={{ maxWidth: "200px", width: "100%" }}
                      >
                        {service.btn}{" "}
                        <span>
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            class="bi bi-caret-right-fill"
                            viewBox="0 0 16 16"
                          >
                            <path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z" />
                          </svg>
                        </span>
                      </button>
                    </HashLink>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default Services;
